// extracted by mini-css-extract-plugin
var _1 = "JoHUHj";
var _2 = "OmbFjM";
var _3 = "OGaZ0G";
var _4 = "zHTj5r";
var _5 = "DTJy5N";
var _6 = "SxGum4";
var _7 = "i6j_0S";
var _8 = "GqVXZu";
var _9 = "wszoRg";
var _a = "xMamh2";
export { _1 as "disabled", _2 as "ease-transition", _3 as "fullWidth", _4 as "gradient-titanic-80", _5 as "linear-transition-05", _6 as "root", _7 as "shadow-medium-titanic", _8 as "shadow-medium-titanic-hover", _9 as "shadow-titanic-1", _a as "shadow-white" }
